import React from 'react';
import { Layout, Avatar, Dropdown, Space, Typography } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profil',
      onClick: () => navigate('/profile'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Déconnexion',
      onClick: handleLogout,
    },
  ];

  return (
    <AntHeader
      style={{
        padding: '0 24px',
        background: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: 250,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}
    >
      <div>
        <Text strong style={{ fontSize: '18px' }}>
          Bonjour, {user?.first_name} {user?.last_name}
        </Text>
      </div>
      
      <Dropdown
        menu={{ items: menuItems }}
        placement="bottomRight"
        arrow
      >
        <Space style={{ cursor: 'pointer' }}>
          <Avatar
            size="small"
            icon={<UserOutlined />}
            src={user?.avatar}
          />
          <Text>{user?.email}</Text>
        </Space>
      </Dropdown>
    </AntHeader>
  );
};

export default Header;
